import * as React from 'react';
import { createApiCaller } from '../../infrastructure/api/ApiFactory';
import { KonkurrenceTilLaerer } from '../../models/KonkurrenceTilLaerer';
import { PageWrapper } from '../../uiComponents/layout/PageWrapper';
import { PageTitle } from '../../uiComponents/layout/PageTitle';
import { ContentWrapper } from '../../uiComponents/layout/ContentWrapper';
import { SectionGroup } from '../../uiComponents/layout/SectionGroup';
import { Section } from '../../uiComponents/layout/Section';
import { EmptyState } from '../../uiComponents/EmptyState';
import { Spinner } from '../../uiComponents/Spinner';
import KonkurrenceTilLaererEksternTable from './KonkurrenceTilLaererEksternTable';
import { getLoggedInBruger } from '../../infrastructure/Security';
import { BrugerRolleEnum } from '../../models/enums/BrugerRolleEnum';
import { KonkurrenceTilEkstern } from '../../models/KonkurrenceTilEkstern';

export interface KonkurrenceListLaererProps {
}

interface KonkurrenceListLaererState {
    konkurrencer?: KonkurrenceTilLaerer[] | KonkurrenceTilEkstern[];
}

class KonkurrenceListLaerer extends React.Component<KonkurrenceListLaererProps, KonkurrenceListLaererState> {
    constructor(props: KonkurrenceListLaererProps) {
        super(props);

        this.state = { konkurrencer: undefined };
    }

    componentDidMount() {
        const self = this;
        const rolle = getLoggedInBruger().rolle;
        if (rolle === BrugerRolleEnum.Laerer) {
            createApiCaller().GetTidligereKonkurrencerTilLaerer().then(result =>
                self.setState({ konkurrencer: result })
            );
        } else {
            createApiCaller().GetTidligereKonkurrencerTilEkstern().then(result =>
                self.setState({ konkurrencer: result })
            );
        }

    }

    render() {    
        if (this.state.konkurrencer === undefined) {
            return <Spinner />;
        }

        return (
            <PageWrapper>
                <PageTitle title='Konkurrencer' />
                <ContentWrapper>
                    <SectionGroup header='Tidligere konkurrencer'>
                        {this.state.konkurrencer.length === 0 &&
                            <EmptyState header='Du har ingen tidligere konkurrencer' />
                        }
                        {this.state.konkurrencer.length > 0 &&
                            <Section fullWidth={true}>
                                <KonkurrenceTilLaererEksternTable konkurrencer={this.state.konkurrencer} />
                            </Section>
                        }
                    </SectionGroup>
                </ContentWrapper>
            </PageWrapper>
        );
    }
}

export default KonkurrenceListLaerer;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/konkurrence/KonkurrenceListLaererEkstern.tsx